// extracted by mini-css-extract-plugin
export default {"formItemStyles":"WorkStationTable_formItemStyles__oMhoA"};